import React, { useEffect, useState } from "react";
import { Container, Col, Row, Button, Form, Card } from "react-bootstrap";
import AllHeader from "../../components/AllHeader";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import LoaderBtn from "../../components/LoaderBtn";
import { toast } from "react-toastify";
import axiosInstance from "../../api/axiosInstance";
import useCheckUser from "../../custom-hooks/useCheckUser";
import BigLoader from "../../components/BigLoader";
import Parent from "../../container/Parent";
import message from "../../assets/Icon/message4.png";

function Made100Messages() {
  const [load, setLoad] = useState(false);
  const [isSend, setIsSend] = useState(false);
  const [messagesInfoList, setMessagesInfoList] = useState([]);
  const [messageMade100, setMessageMade100] = useState("");
  const TokenId = localStorage.getItem("tokenId");
  const Mobile = localStorage.getItem("user_mobile");
  const UserID = localStorage.getItem("UserId");
  const Name = localStorage.getItem("user_namefamily");

  useCheckUser(UserID); //بود به صفحه لاگین برگرده UserId === null هوک برای چک کردن اینکه اگه

  useEffect(() => {
    if (UserID !== null) {
      // دریافت پیامک ماده صد
      setLoad(true);
      axiosInstance
        .post("GetMade100Messages", {
          mobile: Mobile,
          token: TokenId,
        })
        .then((res) => {
          setLoad(false);
          if (res.data.result === "true") {
            setMessagesInfoList(res.data.data);
          } else {
            toast.error(res.data.message, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
            });
          }
        });
    }
  }, [isSend]);

  const handleSendMessage = (e) => {
    e.preventDefault();
    if (messageMade100 === "" || messageMade100 === null || messageMade100 === undefined) {
        toast.error("لطفا پیام خود را وارد نمایید", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        return;
    }
    setLoad(true);
    axiosInstance
      .post("SendMade100Message", {
        mobile: Mobile,
        token: TokenId,
        Message: messageMade100,
      })
      .then((res) => {
        setLoad(false);
        if (res.data.result === "true") {
          if (isSend === false) {
            setIsSend(true);
          } else {
            setIsSend(false);
          }
          toast.success(res.data.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        } else {
          toast.error(res.data.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        }
      });
  };

  return (
    <div className="rgc-pages">
      <AllHeader>
        <span>ارسال پیام ماده 100</span>
      </AllHeader>
      <Container>
        <Parent>
          <Row className="p-3">
            <Col xs={12}>
              <Form>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <div className="msg-title mb-3">
                    <img src={message} alt="" />
                    <Form.Label className="mb-0">ارسال پیام</Form.Label>
                  </div>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    className="rgc-font-number"
                    placeholder="لطفا متن پیام خود را وارد کنید..."
                    type="text"
                    value={messageMade100}
                    onChange={(e) => setMessageMade100(e.target.value)}
                  />
                </Form.Group>

                <Button
                  className="btn-fill rgc-btn w-8rem m-auto py-2"
                  type="submit"
                  variant="primary"
                  onClick={(e) => handleSendMessage(e)}
                >
                  <LoaderBtn loads={load} />
                  <span>ثبت</span>
                </Button>
              </Form>
            </Col>
          </Row>
        </Parent>

       {messagesInfoList.length !==0 &&
        <div className="msg-wrapper mt-3">
          <Row className="gy-3">
            <Col xs={12}>
              <div className="msg-title">
                <img src={message} alt="" />
                <h6>لیست پیام ها</h6>
              </div>
            </Col>
            {messagesInfoList.map((data, index) => {
              return (
                <Col xs={12} key={index}>
                  <div className="msg-body">
                    <div className="msg-header d-flex justify-content-between align-items-center">
                      <div>
                        <span className="text-secondary">{data.FromManager === true ? "مدیر" : Name}</span>
                        <span className="pe-3 text-secondary">{data.SendDateShamsi}</span>
                      </div>
                      {data.IsSeen === true ? (
                        <div className="text-success">
                          <span>دیده شده</span>
                        </div>
                      ) : (
                        <div className="text-secondary">
                          <span>دیده نشده</span>
                        </div>
                      )}
                    </div>

                    <div className="msg-txt">
                      <p>{data.Message}</p>
                    </div>
                  </div>
                </Col>
              );
            })}
          </Row>
        </div>
        }
      </Container>
      <BigLoader loading={load} />
    </div>
  );
}

export default Made100Messages;
